import React, { useState, useEffect, useRef } from 'react';
import { useStoreState } from 'easy-peasy';
import NewStepper from '../../stepper/stepper';
import UserCreation from './userCreation';
import CreatePassword from './createPassword';
import SuccessToLogin from './successToLogin';
import UserService from "../../../../../services/userService";
import { PRODUCT } from '../../../../../models/websiteTypesConstants';
import AdobeScript from '../../../../../services/adobeScript';

const Started = ({ applicantId }) => {
  const userService = UserService();
  const adobe = new AdobeScript();
  const brandSettings = useStoreState(state => state.siteSettingsModel.brandSettings);
  const [showWizard, setShowWizard] = useState(false);
  const steps = [
    {
      label: "Create Username",
      description: "Choose a unique username",
    },
    {
      label: "Create Password",
      description: "Choose a strong password",
    },
    {
      label: "Finish",
      description:
        "You're ready to access your account",
    },
  ];
  const [isUserValid, setIsUserValid] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const userCreationRef = useRef(null);
  const createUserHandler = async () => {
    await userService.createUser(applicantId);
  };

  useEffect(() => {
    adobe.setup();
  }, [])

  const validateStep = async (i) => {
    if (i === 0) {
      if (!isUserValid || !userCreationRef.current) return false;
      return await userCreationRef.current.checkAvailability();
    }
    if (i === 1) return isPasswordValid;
    return true;
  };

  const onGetStartedClick = () => {
    setShowWizard(true);
    adobe.event("startRegistration");
  }

  if (showWizard) {
    return (
      <div className='row mt-4 cfcregister'>
        <div className='card gbCard w-100' style={{ background: 'transparent' }}>
          <div className='card-body' style={{ background: 'transparent' }}>
            <NewStepper
              steps={steps}
              isNextDisabled={(i) => (i === 0 && !isUserValid)}
              isCompleteDisabled={(i) => (i === 1 && (!isPasswordValid))}
              agreeCallback={createUserHandler}

              renderStepContent={(i) => {
                if (i === 0) return <UserCreation ref={userCreationRef} onValidityChange={setIsUserValid} applicantId={applicantId} />;
                if (i === 1) return <CreatePassword onValidityChange={setIsPasswordValid} applicantId={applicantId} />;
                if (i === 2) return <SuccessToLogin />;
                return null;
              }}

              validateStep={validateStep}
              onCancel={() => setShowWizard(false)}
              onFinish={() => {
                setShowWizard(false);
              }}

              getActionsForStep={(i) => {
                if(i == 0) return ['cancel', 'next'];
                if (i === 1) return ['cancel', 'complete registration'];
                return [];
              }}

              styles={{
                stepper: { maxWidth: 640, margin: '0 auto' },
                actions: { maxWidth: 405, margin: '24px auto 0' },
                buttonNext: { minWidth: 120, height: 40 },
                buttonConfirm: { minWidth: 200, height: 40 },
                buttonCancel: { minWidth: 120, height: 40 },
              }}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="row my-4">
        <div style={{ background: brandSettings.Primary, cursor: 'default', color: 'white' }} className="btn w-100 mb-0 p-3">
          <strong>Register for Online Access!</strong>
        </div>
      </div>
      <div className='row mt-4 cfcregister'>
        <div className='card gbCard w-100'>
          <div className='card-body no-bottom-margin  row' style={{ "marginBottom": "0 !important" }}>
            <div className='col-12'>

              <div className='row m-0'>
                <div className='hidden-desk col-sm-12 col-xs-12 '>
                  <img className='cfc-mini-pcicon' src='/registration.png' alt='cfc login page image'></img>
                </div>
                <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12 text-container pb-0'>
                  <div className='row'>
                    <div className='col-12 text-left'>
                      <h1>Welcome to <span style={{ color: brandSettings.Secondary }}>{brandSettings.ProductName} Mastercard!</span></h1>
                      <p>
                        You're almost there! Let's complete your registration to manage your card online and through our mobile app.
                      </p>
                    </div>
                    <div className='col-12 text-center'>
                      <button
                        type='button'
                        className="btn btn-block text-small mt-3 mt-0 btn-info redirectbtn"
                        style={{ backgroundColor: brandSettings.Secondary, color: "#fff" }}
                        onClick={() => onGetStartedClick()}
                      >
                        GET STARTED
                      </button>
                    </div>
                  </div>
                </div>
                <div className='hidden-phone  col-lg-6 col-md-6 '>
                  <img className='cfc-mini-pcicon' src={`${brandSettings.ProductName === PRODUCT.Grand.bank ? '/gbRegistration.png' : '/registration.png'}`} alt='cfc login page image'></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
};

export default Started;
